import { Link } from 'react-router-dom';

interface CategoryCardProps {
  slug: string;
  name: string;
  icon: string;
  description: string;
  imageUrl: string;
}

function CategoryCard({ slug, name, icon, description, imageUrl }: CategoryCardProps) {
  return (
    <Link
      to={`/category/${slug}`}
      className="group relative rounded-xl overflow-hidden aspect-[4/5] bg-background-100 cursor-pointer"
    >
      <img
        src={imageUrl}
        alt={name}
        className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent"></div>
      <div className="absolute bottom-0 left-0 right-0 p-3 md:p-4">
        <div className="w-8 h-8 flex items-center justify-center bg-white/20 rounded-lg mb-2">
          <i className={`${icon} text-background-50 text-sm`}></i>
        </div>
        <h3 className="text-sm md:text-base font-medium text-background-50 mb-1">{name}</h3>
        <p className="text-xs text-background-300 line-clamp-1">{description}</p>
      </div>
    </Link>
  );
}

export default function CategorySection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-3xl md:text-4xl text-foreground-900 mb-3">
            探索视频分类
          </h2>
          <p className="text-foreground-500 text-sm max-w-xl mx-auto">
            六大精选分类，覆盖各类热门视频内容，总有一款适合您
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          <CategoryCard
            slug="dongzuo"
            name="动作大片"
            icon="ri-film-line"
            description="热血激燃的动作电影，震撼视觉体验"
            imageUrl="https://readdy.ai/api/search-image?query=Epic%20action%20movie%20scene%20with%20explosive%20cinematic%20lighting%2C%20dramatic%20composition%2C%20warm%20golden%20and%20dark%20tones%2C%20professional%20film%20photography%20style%2C%20intense%20atmosphere%2C%20clean%20background%20with%20subtle%20grain%20texture&width=400&height=300&seq=cat-action&orientation=landscape"
          />
          <CategoryCard
            slug="xiju"
            name="喜剧搞笑"
            icon="ri-emotion-laugh-line"
            description="轻松欢笑的喜剧佳作，放松心情首选"
            imageUrl="https://readdy.ai/api/search-image?query=Bright%20cheerful%20comedy%20scene%20with%20warm%20lighting%2C%20playful%20colorful%20atmosphere%2C%20cinematic%20composition%2C%20joyful%20vibrant%20tones%2C%20professional%20film%20photography%2C%20clean%20minimal%20background&width=400&height=300&seq=cat-comedy&orientation=landscape"
          />
          <CategoryCard
            slug="juqing"
            name="剧情文艺"
            icon="ri-heart-line"
            description="深刻感人的剧情故事，触动心灵之作"
            imageUrl="https://readdy.ai/api/search-image?query=Emotional%20drama%20film%20scene%20with%20soft%20natural%20lighting%2C%20warm%20intimate%20atmosphere%2C%20cinematic%20depth%20of%20field%2C%20muted%20earthy%20tones%2C%20artistic%20film%20photography%2C%20gentle%20gradient%20background&width=400&height=300&seq=cat-drama&orientation=landscape"
          />
          <CategoryCard
            slug="kehuan"
            name="科幻奇幻"
            icon="ri-rocket-line"
            description="脑洞大开的科幻世界，探索未知领域"
            imageUrl="https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20cinematic%20scene%20with%20neon%20accents%20and%20deep%20space%20atmosphere%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20cool%20and%20warm%20contrast%20tones%2C%20professional%20film%20photography%2C%20clean%20gradient%20background&width=400&height=300&seq=cat-scifi&orientation=landscape"
          />
          <CategoryCard
            slug="jilu"
            name="纪录纪实"
            icon="ri-camera-lens-line"
            description="真实世界的精彩记录，开阔视野之窗"
            imageUrl="https://readdy.ai/api/search-image?query=Documentary%20style%20cinematic%20scene%20with%20natural%20earthy%20lighting%2C%20authentic%20atmospheric%20composition%2C%20warm%20neutral%20tones%2C%20professional%20documentary%20photography%2C%20clean%20soft%20background%20with%20organic%20textures&width=400&height=300&seq=cat-doc&orientation=landscape"
          />
          <CategoryCard
            slug="dongman"
            name="动漫动画"
            icon="ri-palette-line"
            description="精美绝伦的动画世界，视觉艺术盛宴"
            imageUrl="https://readdy.ai/api/search-image?query=Beautiful%20anime%20art%20style%20cinematic%20scene%20with%20vibrant%20colors%20and%20soft%20lighting%2C%20artistic%20composition%2C%20warm%20pastel%20tones%2C%20professional%20animation%20art%20style%2C%20clean%20gradient%20background%20with%20dreamy%20atmosphere&width=400&height=300&seq=cat-anime&orientation=landscape"
          />
        </div>
      </div>
    </section>
  );
}